module.exports = __webpack_public_path__ + "static/media/4.ac4db9ef.svg";